import { Controller, ControlProps } from '../types';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface OrderControlProps extends ControlProps {}

interface OrderHandlers {
  set: (name: string, newOrder: number) => void;
}

export const OrderControllerId = 'ORDER';
export interface OrderController extends Controller<OrderHandlers> {
  id: typeof OrderControllerId;
}
